import React from 'react';
import Header from '../components/Header';
import About from '../components/About';
import Footer from '../components/Footer';

function AboutPage() {
  return (
    <>
      <Header />
      <main>
        <About />
      </main>
      <Footer />
    </>
  );
}

export default AboutPage;
